/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MdClose, MdEmail } from 'react-icons/md';
import { CgPhone } from 'react-icons/cg';
import { HiOutlineMenuAlt1 } from 'react-icons/hi';
import PropTypes from 'prop-types';

import IdeaFactoryLogo from '../../assets/images/logo.png';

import Button from '../inputs/Button';
import { toggleScroll } from '../../utilities/general';

function Header({ solidBg }) {
  const location = useLocation();
  const navigate = useNavigate();

  const [scrolled, setScrolled] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const func = () => setScrolled(window.pageYOffset > 30);

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', func);
    }
    func();

    return (() => {
      window.removeEventListener('scroll', func);
    });
  }, []);

  useEffect(() => {
    toggleScroll();

    return () => setTimeout(() => {
      toggleScroll();
    }, 0);
  }, [showMenu]);

  return (
    <>
      <header className={`w-full h-[106px] top-0 z-40 overflow-hidden sticky bg-white transition-shadow duration-300 ${
        scrolled || solidBg ? 'shadow-md' : 'border-b'
      }`}
      >
        <div className="content">
          <div className="w-full flex items-center justify-between py-8">
            <div className="logo">
              <Link to="/">
                <img src={IdeaFactoryLogo} className="w-24 h-auto" alt="Idea Factory Logo" />
              </Link>
            </div>
            <div className="nav-links hidden lg:block">
              <ul className="flex items-center space-x-12 text-xs font-semibold uppercase tracking-widest">
                <li>
                  <Link
                    to="/#top"
                    className={`hover:text-primary transition-colors py-2 border-b-2 ${
                      location.pathname === '/' && !location.hash ? 'text-primary border-primary' : 'text-textColor border-transparent'
                    }`}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/#schools"
                    className={`hover:text-primary transition-colors py-2 border-b-2 ${
                      location.hash === '#schools' ? 'text-primary border-primary' : 'text-textColor border-transparent'
                    }`}
                  >
                    Schools
                  </Link>
                </li>
                <li>
                  <Link
                    to="/programs"
                    className={`hover:text-primary transition-colors py-2 border-b-2 ${
                      location.pathname === '/programs' ? 'text-primary border-primary' : 'text-textColor border-transparent'
                    }`}
                  >
                    Courses
                  </Link>
                </li>
                <li>
                  <Link
                    to="/gallery"
                    className={`hover:text-primary transition-colors py-2 border-b-2 ${
                      location.pathname === '/gallery' ? 'text-primary border-primary' : 'text-textColor border-transparent'
                    }`}
                  >
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about-us"
                    className={`hover:text-primary transition-colors py-2 border-b-2 ${
                      location.pathname === '/about-us' ? 'text-primary border-primary' : 'text-textColor border-transparent'
                    }`}
                  >
                    About Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="items-center space-x-4 hidden lg:flex">
              <Button paddingX="px-10" paddingY="py-2.5" onClick={() => navigate('/sign-in')}>Login</Button>
            </div>
            <div className="lg:hidden">
              <HiOutlineMenuAlt1 className="w-8 h-auto cursor-pointer" onClick={() => setShowMenu(true)} />
            </div>
          </div>
        </div>
      </header>

      <div
        role="presentation"
        onClick={(e) => (e?.target?.classList?.contains('side-menu') && setShowMenu(false))}
        className={`header-side-menu ${showMenu ? 'show overlay' : ''} fixed z-40 top-0 left-0 w-full h-screen bg-black bg-opacity-40`}
      >
        <div className="bg-white w-full absolute right-0 top-0 h-full overflow-y-auto">
          <div className="w-full relative">
            <div className="flex justify-between px-5 py-8">
              <div className="logo">
                <Link to="/">
                  <img src={IdeaFactoryLogo} className="w-24 h-auto" alt="Idea Factory Logo" />
                </Link>
              </div>
              <button
                type="button"
                onClick={() => setShowMenu(false)}
                className="font-bold flex items-center hover:bg-opacity-20 hover:bg-primary"
              >
                <MdClose className="w-10 h-auto" />
              </button>
            </div>
            <div className="w-full px-10 py-8">
              <ul className="w-full">
                <Link to="/#top" onClick={() => setShowMenu(false)}>
                  <li className={`${location.pathname === '/' && (location.hash === '' || location.hash === '#top') ? 'bg-primary bg-opacity-20' : ''} header-side-link`}>
                    Home
                  </li>
                </Link>
                <Link to="/#schools" onClick={() => setShowMenu(false)}>
                  <li className={`${location.hash === '#schools' ? 'bg-primary bg-opacity-20' : ''} header-side-link`}>
                    Schools
                  </li>
                </Link>
                <Link to="/programs" onClick={() => setShowMenu(false)}>
                  <li className={`${location.pathname === '/programs' ? 'bg-primary bg-opacity-20' : ''} header-side-link`}>
                    Courses
                  </li>
                </Link>
                <Link to="/gallery" onClick={() => setShowMenu(false)}>
                  <li className={`${location.pathname === '/gallery' ? 'bg-primary bg-opacity-20' : ''} header-side-link`}>
                    Gallery
                  </li>
                </Link>
                <Link to="/about-us" onClick={() => setShowMenu(false)}>
                  <li className={`${location.pathname === '/about-us' ? 'bg-primary bg-opacity-20' : ''} header-side-link`}>
                    About us
                  </li>
                </Link>
              </ul>

              <div className="w-full border-t py-10 mt-5">
                <div className="justify-center flex gap-4">
                  <Button
                    paddingX="px-10"
                    paddingY="py-2.5"
                    onClick={() => {
                      navigate('/sign-in');
                      setShowMenu(false);
                    }}
                  >
                    Login
                  </Button>
                  <Button
                    paddingX="px-10"
                    paddingY="py-2.5"
                    onClick={() => {
                      navigate('/#contact-us');
                      setShowMenu(false);
                    }}
                  >
                    Contact Us
                  </Button>
                </div>
                <div className="w-full mt-8">
                  <h1 className="font-bold font-title text-lg text-center mb-2">Get in touch</h1>
                  <div className="flex justify-center space-x-3 items-center mb-3">
                    <CgPhone className="text-primary w-6 h-auto" />
                    <span className="text-sm">0903 096 6040</span>
                  </div>
                  <div className="flex justify-center space-x-3 items-center">
                    <MdEmail className="text-primary w-6 h-auto" />
                    <span className="text-sm">purpleacademy@wemabank.com</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

Header.propTypes = {
  solidBg: PropTypes.bool
};

Header.defaultProps = {
  solidBg: false
};

export default Header;
